import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

// ─── CREATIONS ────────────────────────────────────────────────────────────────

export const HelixCreationsGetCrqsToCreateRequest = (history = false) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}HelixCrqs/GetCrqsToCreate`,
	params: { history },
	hasLoading: false,
});

export const HelixCreationsGetCrqsOnQueueWithErrorRequest = (history = false) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}HelixCrqs/GetCrqsOnQueueWithError`,
	params: { history },
	hasLoading: false,
});

export const HelixCrqsToCreateRequest = (userId, action, idList, crqChangeIds, bot = 0) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}HelixCrqs/CrqsToCreateAction`,
	params: { userId, action, bot },
	data: { idList, crqChangeIds },
	hasLoading: true,
});

export const HelixExportCrqsCreationsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}HelixCrqs/ExportCrqsCreations`,
	hasLoading: false,
});

export const HelixCrqsOnQueueWithErrorRequest = (userId, action, idList, crqChangeIds, bot = 0) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}HelixCrqs/CrqsOnQueueWithErrorAction`,
	params: { userId, action, bot },
	data: { idList, crqChangeIds },
	hasLoading: true,
});

// ─── CHANGES ──────────────────────────────────────────────────────────────────

export const HelixChangesGetCrqsToCloseRequest = (history = false) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}HelixCrqs/GetCrqsToClose`,
	params: { history },
	hasLoading: false,
});

export const HelixChangesGetCrqsToCancelRequest = (history = false) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}HelixCrqs/GetCrqsToCancel`,
	params: { history },
	hasLoading: false,
});

export const HelixChangesGetCrqsToApproveRequest = (history = false) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}HelixCrqs/GetCrqsToApprove`,
	params: { history },
	hasLoading: false,
});

export const HelixCrqsToChangeActionRequest = (userId, action, idList, crqChangeIds, bot = 0) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}HelixCrqs/CrqsToChangeAction`,
	params: { userId, action, bot },
	data: { idList, crqChangeIds },
	hasLoading: true,
});

export const HelixExportCrqsChangesRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}HelixCrqs/ExportCrqsChanges`,
	hasLoading: false,
});

// ─── OTHER ────────────────────────────────────────────────────────────────────

export const HelixChangesGetCrqsWithConflictsRequest = (history = false) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}HelixCrqs/GetCrqsWithConflicts`,
	params: { history },
	hasLoading: false,
});

export const HelixChangesGetCrqsToAddActivityRequest = (history = false) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}HelixCrqs/GetCrqsToAddActivity`,
	params: { history },
	hasLoading: false,
});

export const HelixCrqsWithConflictsRequest = (userId, action, idList, crqChangeIds, bot = 0) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}HelixCrqs/CrqsWithConflictsAction`,
	params: { userId, action, bot },
	data: { idList, crqChangeIds },
	hasLoading: true,
});

export const HelixExportCrqsOtherRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}HelixCrqs/ExportCrqsOther`,
	hasLoading: false,
});

export const HelixCrqsToAddActivityRequest = (userId, action, idList, crqChangeIds, bot = 0) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}HelixCrqs/CrqsToAddActivityAction`,
	params: { userId, action, bot },
	data: { idList, crqChangeIds },
	hasLoading: true,
});

// ─── UPLOAD ───────────────────────────────────────────────────────────────────

export const HelixGetBotSummaryRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}HelixCrqs/GetBotSummary`,
	hasLoading: false,
});

export const HelixUploadCrqsToCreateRequest = (userId, bot, file) => {
	const formData = new FormData();
	formData.append('file', file);
	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}HelixCrqs/UploadCrqsToCreate`,
		params: { userId, bot },
		data: formData,
		hasLoading: true,
	});
};

export const HelixUploadCrqsToChangeRequest = (userId, bot, file) => {
	const formData = new FormData();
	formData.append('file', file);
	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}HelixCrqs/UploadCrqsToChange`,
		params: { userId, bot },
		data: formData,
		hasLoading: true,
	});
};

export const HelixUploadCrqsToAddActivityRequest = (userId, bot, file) => {
	const formData = new FormData();
	formData.append('file', file);
	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}HelixCrqs/UploadCrqsToAddActivity`,
		params: { userId, bot },
		data: formData,
		hasLoading: true,
	});
};

export const HelixUploadLockedUnlockedRequest = (userId, file) => {
	const formData = new FormData();
	formData.append('file', file);
	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}HelixCrqs/UploadLockedUnlocked`,
		params: { userId },
		data: formData,
		hasLoading: true,
	});
};

// ─── DOWNLOAD TEMPLATES ───────────────────────────────────────────────────────

export const HelixCreationsDownloadTemplateRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}HelixCrqs/DownloadCreationsTemplate`,
	hasLoading: true,
});

export const HelixChangesDownloadTemplateRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}HelixCrqs/DownloadChangesTemplate`,
	hasLoading: true,
});

export const HelixAddActivityDownloadTemplateRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}HelixCrqs/DownloadAddActivityTemplate`,
	hasLoading: true,
});

// ─── STATISTICS ───────────────────────────────────────────────────────────────

export const HelixGetStatisticsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}HelixCrqs/GetStatistics`,
	hasLoading: false,
});

export const HelixExportCrqsStatisticsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}HelixCrqs/ExportCrqsStatistics`,
	hasLoading: true,
});